export default __webpack_public_path__ + "src/assets/press.d061b4f246c29611b191e14031d79477.svg";